/**
 * Stable action names shared by Auto Apply Signals and RUM errors.
 *
 * User-triggered failures use the same value as the originating Signals button.
 * Background operations keep an operation-specific value because they have no button event.
 */
export const AutoApplyAction = {
    ValidateDrafts: 'validate-drafts',
    LoadDraft: 'load-draft',
    LoadPreview: 'load-preview',
    Load: 'load',
    Update: 'update',
    ReviewApplication: 'review_application',
    UploadFile: 'upload-file',
    CreatePreview: 'create-preview',
    SubmitApplications: 'submit-applications',
    VerifySubmission: 'verify-submission',
} as const;
